
    // Assign the environment variable to window.env
    console.log(window.env.VITE_SERVER)

    // Dynamically create and append the Google Analytics script tag
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${window.env.VITE_GA_TAG}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize Google Analytics
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());

      // Set up the GA tag
      gtag('config', window.env.VITE_GA_TAG);
    };
  